<div class="page-container">
  <app-card>
    <app-card-header>
      <app-card-title>{{ 'reports.objectionBreakdown.title' | translate }}</app-card-title>
    </app-card-header>
    <app-card-content>
      <app-report-filter-bar [includeAllUsers]="includeAllUsers" (filtersChange)="onFiltersChange($event)" />

      @if (loading()) {
        <div class="loading-container flex flex-column flex-align-center p-lg no-print">
          <app-spinner />
        </div>
      } @else if (rows().length === 0) {
        <p class="empty-state" data-testid="objection-breakdown-empty">{{ 'reports.objectionBreakdown.empty' | translate }}</p>
      } @else {
        <table class="report-table" data-testid="objection-breakdown-table">
          <thead>
            <tr>
              <th>{{ 'reports.objectionBreakdown.objection' | translate }}</th>
              <th>{{ 'reports.objectionBreakdown.count' | translate }}</th>
              <th>{{ 'reports.objectionBreakdown.percentOfTotal' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows(); track row.objectionId) {
              <tr [attr.data-testid]="'objection-row-' + row.objectionId">
                <td>{{ row.objectionLabel }}</td>
                <td>{{ row.count }}</td>
                <td>{{ (row.percentOfTotal * 100).toFixed(1) }}%</td>
              </tr>
            }
          </tbody>
        </table>
      }
    </app-card-content>
    @if (canExport) {
      <app-card-actions class="no-print">
        <app-button variant="outlined" (click)="exportCsv()" data-testid="export-csv-button">
          <app-icon name="download" [size]="16" />
          {{ 'reports.exportCsv' | translate }}
        </app-button>
        <app-button variant="outlined" (click)="exportXlsx()" data-testid="export-xlsx-button">
          <app-icon name="download" [size]="16" />
          {{ 'reports.exportXlsx' | translate }}
        </app-button>
      </app-card-actions>
    }
  </app-card>
</div>
